import {Component, OnInit} from '@angular/core';
import {SidebarService} from '../services/side-bar.service';
import {TaskBarService} from '../services/task-bar.service';
import {Location} from '@angular/common';
import {Router, RoutesRecognized, NavigationStart} from '@angular/router';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/pairwise';

@Component({
  selector: 'app-content-page',
  templateUrl: './content-page.component.html',
  styleUrls: ['./content-page.component.css']
})
export class ContentPageComponent implements OnInit {
  loadedFeature = 'home-task';
  previousRoute: string;
  nextRoute: string;

  constructor(
    public sidebarService: SidebarService,
    public taskbarService: TaskBarService,
    private _location: Location,
    private router: Router
  ) {

    this.router.events
      .filter(e => e instanceof RoutesRecognized)
      .pairwise()
      .subscribe((event: any[]) => {
        this.previousRoute = event[0].urlAfterRedirects;
        localStorage.setItem('prevRoute', this.previousRoute);
      });

    this.router.events
      .filter(e => e instanceof NavigationStart)
      .pairwise()
      .subscribe((event: any[]) => {
        this.nextRoute = event[1].url;
        localStorage.setItem('nextRoute', this.nextRoute);
      });

  }

  ngOnInit() {
  }

  onNavigate(feature: string) {
    this.loadedFeature = feature;
  }

  goBack() {
    this._location.back();
  }

  backToList() {
    this.router.navigateByUrl('/dashboard/operating-standards');
  }

  public isBackBtnHidden() {
    let list: string[], route: string;
    list = [
      "/dashboard/testing",
      "/dashboard",
      "/dashboard/home",
      "/dashboard/groups",
      "/dashboard/operating-standard",
      "/dashboard/standards",
      "/dashboard/company-structure",
      "/dashboard/admin/register-user",
      "/dashboard/admin/create-group",
      "/dashboard/admin/create-position",
      "/dashboard/admin/create-schedule",
      "/dashboard/admin/create-standard",
      "/dashboard/admin/all-standards",
      "/dashboard/admin/all-standards-head",
      "/dashboard/operating-standards",
      "/dashboard/profile",
      "/dashboard/create-operating-standard",
      "/dashboard/create-operating-standard/step-two",
      "/dashboard/create-operating-standard/step-three",
      "/dashboard/create-operating-standard/step-four",
      "/dashboard/create-operating-standard/step-five",
      "/dashboard/create-operating-standard/step-six",
      "/dashboard/create-operating-standard/step-seven",
      "/dashboard/create-operating-standard/step-eight",
      "/dashboard/create-operating-standard/add-user-steps",
      "/dashboard/specializations-list",
      "/dashboard/create-suggestion-list",
      "/dashboard/my-suggestion-lists",
      "/dashboard/all-suggestion-lists",
      "/dashboard/add-specialization",
      "/dashboard/learning",
      "/dashboard/edit-specialization",
      "/dashboard/start-learning",
      "/dashboard/admin/users"
    ];
    route = this._location.path();
    // I have no excuse for this
    if (list.indexOf(route) > -1) {
      return !(route === '/dashboard/standards' && localStorage.getItem('prevRoute') === '/dashboard/testing');
    } else {
      return false;
    }
  }

  public backToListHidden() {
    let list: string[], route: string;
    list = [
      "/dashboard/create-operating-standard",
      "/dashboard/create-operating-standard/step-two",
      "/dashboard/create-operating-standard/step-three",
      "/dashboard/create-operating-standard/step-four",
      "/dashboard/create-operating-standard/step-five",
      "/dashboard/create-operating-standard/step-six",
      "/dashboard/create-operating-standard/step-seven",
      "/dashboard/create-operating-standard/step-eight",
      "/dashboard/create-operating-standard/add-user-steps"
    ];
    route = this._location.path();
    if (list.indexOf(route) > -1) {
      return false;
    } else {
      return true;
    }
  }

}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/content-page.component.ts